import { CustomConverter, DateTimeConverter, JsonObject, JsonProperty, NotNull, Optional } from 'json-ts-mapper';
import { Article } from './article';

@JsonObject
export class Devis {
  constructor (
    id?: number,
    article?: Article,
    dateCreation?: Date,
    username?: string
  ) {
    this.id = id;
    this.article = article;
    this.dateCreation = dateCreation;
    this.username = username;
  }

  @JsonProperty(Number)
  id: number;

  @JsonProperty(Article)
  @NotNull
  article: Article;

  @JsonProperty(String)
  @Optional
  username: string;

  @JsonProperty(String)
  @CustomConverter(DateTimeConverter)
  @Optional
  dateCreation: Date;
}
